'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');
var title = 'Gender Equality Funds';
var description = 'Score your investments for gender equality. Gender Equality Funds is a platform that informs and empowers everyday investors.';
var domain = process.env.DOMAIN || 'https://genderequalityfunds.org';
// if were not the client (window) use the injected config otherwise create it
var Version = require('./data/Version.json');
var FootprintRanges = require('./data/FootprintRanges.json');
var TargetDateSeries = require('./data/TargetDateSeries.json');
var CoreBenchmarks = require('./data/CoreBenchmarks.json');
var ExtendedBenchmarks = require('./data/ExtendedBenchmarks.json');
var FamilyFunds = require('./data/FamilyFunds.json');
var FundCategoryAll = require('./data/FundCategoryAll.json');
var FundFamilyAll = require('./data/FundFamilyAll.json');
var GefScoreNormalizersAllScored = require('./data/GefScoreNormalizersAllScored.json');
var GefScoreNormalizersGroups = require('./data/GefScoreNormalizersGroups.json');
var GefScoreNormalizersPeers = require('./data/GefScoreNormalizersPeers.json');
var UssifFundsDiversityEeo = require('./data/UssifFundsDiversityEeo.json');
var UssifFundsDiversityEeoOptions = require('./data/UssifFundsDiversityEeoOptions.json');
var Changelog = require('./data/Changelog.json');
var config = {
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  version: Version['version'],
  description: description,
  domain: domain,
  loggingOff: process.env.LOGGING_OFF,
  httpsRedirect: process.env.HTTPS_REDIRECT,
  gaKey: process.env.GA_KEY,
  apiHost: process.env.APIHOST || 'https://api.fossilfreefunds.org',
  apiPort: process.env.APIPORT || 443,
  imageSocialShare: 'mock-home-head-2.jpg',
  shareMessage: title,
  queryMaxFunds: 10,
  googleVerification: "t-O9GxpeP1TrjOvfOsjp-NM8ilTRt7MapdrFLO5m5cQ",
  imgPrefix: '../../../static/images/',
  changelog: Changelog,
  gefScoreNormalizers: {
    // 20200917
    overall: 100,
    balance: 100,
    policies: 100,
    //
    allScored: GefScoreNormalizersAllScored['all_scored'],
    groups: GefScoreNormalizersGroups,
    peers: GefScoreNormalizersPeers
  },
  signupForm: {
    url: 'https://go.asyousow.org/l/344561/2018-09-06/cfjmjg',
    id: '344561_37541pi_344561_37541'
  },
  getStartedInput: {
    label: 'Top-scoring funds',
    title: 'Top-scoring funds | Gender Equality Funds',
    faclass: null
  },
  funders: [{
    short_name: 'tara_health',
    long_name: 'Tara Health Foundation',
    link: 'https://tarahealthfoundation.org/'
  }],
  partners: [{
    short_name: 'green_retirement',
    long_name: 'Green Retirement',
    link: 'http://www.greenretirement.com/'
  }, {
    short_name: 'equileap',
    long_name: 'Equileap',
    link: 'https://equileap.org/'
  }, {
    short_name: 'nia_impact_capital',
    long_name: 'Nia Impact Capital',
    link: 'https://www.niaimpactcapital.com/'
  }, {
    short_name: 'hip_investor',
    long_name: 'HIP Investor',
    link: 'https://hipinvestor.com/'
  }, {
    short_name: 'womens_funding_network',
    long_name: "Women's Funding Network",
    link: 'https://www.womensfundingnetwork.org/'
  }, {
    short_name: 'paid_leave',
    long_name: 'PL+US: Paid Leave for the United States',
    link: 'https://paidleave.us/'
  }, {
    short_name: 'confluence_philanthropy',
    long_name: 'Confluence Philanthropy',
    link: 'https://www.confluencephilanthropy.org/'
  }, {
    short_name: 'chip',
    long_name: 'Center for High Impact Philanthropy',
    link: 'https://www.impact.upenn.edu/'
  }, {
    short_name: 'rachels_network',
    long_name: "Rachel's Network",
    link: 'https://rachelsnetwork.org/'
  }, {
    short_name: 'veris',
    long_name: 'Veris Wealth Partners',
    link: 'https://www.veriswp.com/'
  }, {
    short_name: 'womens_fund_rhode_island',
    long_name: "Women's Fund Rhode Island",
    link: 'https://wfri.org/'
  }, {
    short_name: 'wowe',
    long_name: 'Women of the World Endowment',
    link: 'https://wowendowment.org/'
  }],
  ussifFundsDiversityEeo: UssifFundsDiversityEeo,
  ussifFundsDiversityEeoOptions: UssifFundsDiversityEeoOptions,
  socialAppId: '1094061130685792',
  profilePath: 'gender-lens-score',
  routes: {
    home: '/',
    about: '/about',
    howitworks: '/how-it-works',
    toolkit: '/action-toolkit',
    media: '/media',
    list: '/funds',
    clean: '/funds?srt=grade_gender_equality&dsc=false',
    compare: '/compare',
    fund: '/fund',
    targetdate: '/target-date-funds',
    targetDateFunds: '/target-date-funds',
    families: '/families',
    legal: '/legal',
    whyGenderEqualityFunds: '/gender-equality-workplace',
    partners: '/partners',
    indexfunds: '/index-funds',
    notFound: '/not-found-404'
  },
  links: {
    changelog: 'https://iyv-charts.s3-us-west-2.amazonaws.com/files/',
    blog: 'https://blog.genderequalityfunds.org/',
    equileap: 'http://equileap.org/',
    equileapResearch: 'https://equileap.com/equileap-reports/',
    ussif: 'https://www.ussif.org/',
    ussifperf: 'https://www.ussif.org/performance',
    donate: 'https://go.asyousow.org/donate-invest-your-values',
    contact: 'https://www.asyousow.org/contact',
    signup: 'https://go.asyousow.org/sign-up-gender-equality-funds',
    contactStefanie: 'mailto:sspear@asyousow.org?subject=Gender%20Equality%20Funds',
    contactAndrew: 'mailto:andrew*asyousow.org?subject=Gender%20Equality%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    ays: 'http://www.asyousow.org',
    aysabout: 'http://www.asyousow.org/about-us',
    fff: 'https://fossilfreefunds.org',
    dff: 'https://deforestationfreefunds.org',
    gef: 'https://genderequalityfunds.org',
    wff: 'https://weaponfreefunds.org',
    gff: 'https://gunfreefunds.org',
    tff: 'https://tobaccofreefunds.org',
    pff: 'https://prisonfreefunds.org',
    iyv: 'https://investyourvalues.org',
    compareFeedback: 'https://forms.gle/cdJG5C7WoGxKkEx78',
    aysinvest: 'https://www.asyousow.org/invest-your-values/',
    morningstar: 'https://www.morningstar.com/',
    fffFund: 'https://fossilfreefunds.org/funds',
    socialAYSfb: 'https://www.facebook.com/asyousow.org/',
    socialAYStwitter: 'https://twitter.com/asyousow',
    socialAYSinstagram: 'https://www.instagram.com/_asyousow_/'
  },
  blog: [{
    url: 'shifting-capital-in-favor-of-women-girls-and-the-businesses-and-communities-they-empower/',
    image: 'https://blog.genderequalityfunds.org/wp-content/uploads/2020/11/gef_patience_shifting_capital-1024x538.jpg',
    title: 'Shifting Capital in Favor of Women, Girls, and the Businesses and Communities They Empower',
    subtitle: 'COVID-19 has resulted in a substantial decrease in women’s participation in the labor force (its lowest point in 30 years). It is now, more than ever, crucial to accelerate gender equality through the power of capital.',
    date: '2020-12-01'
  }, {
    url: 'grading-mutual-funds-on-gender-pay-gap-parental-leave-and-more/',
    image: 'https://blog.genderequalityfunds.org/wp-content/uploads/2020/10/grade_mutual_funds-1024x538.jpg',
    title: 'Grading Mutual Funds on Gender Pay Gap, Parental Leave, and More',
    subtitle: 'Gender Equality Funds is excited to announce that our mutual fund grading system has evolved, and now incorporates company research covering two additional areas: equal compensation and work life balance, and commitment, transparency, and accountablity.',
    date: '2020-10-08'
  }, {
    url: 'invest-values-resilient-coronavirus-pandemic/',
    image: 'https://blog.genderequalityfunds.org/wp-content/uploads/2020/06/coronavirus-1024x538.jpg',
    title: 'Investing With Your Values Proves Resilient During Coronavirus Pandemic',
    subtitle: 'The COVID-19 crisis has forced entire countries into lockdown, induced widespread panic, triggered economic meltdown, and revealed our society’s profound vulnerability to systemic shocks. But rather than give in to a collective desire to “return to normal,” now is the time to redefine what “normal” is.',
    date: '2020-06-22'
  }],
  footprintRanges: FootprintRanges,
  coreBenchmarks: CoreBenchmarks,
  extendedBenchmarks: ExtendedBenchmarks,
  // asset managers for Family view
  familyFunds: FamilyFunds,
  // target dates
  targetDateSeries: TargetDateSeries,
  engagementFunds: [],
  /*ignore jslint start*/
  formOptions: {
    market: [{ name: 'All funds', value: 'Show all funds' }, { name: 'United States', value: 'US' }],
    type: [{ name: 'All funds', value: 'All funds' }, { name: 'Open-end funds', value: 'FO' }, { name: 'Exchange-traded funds (ETFs)', value: 'FE' }, { name: 'Common/Collective trusts', value: 'TSP' }, { name: 'Variable annuities', value: 'VA' }],
    diversified: [{ name: 'All funds', value: false }, { name: 'Diversified', value: 'false' }, { name: 'Non-diversified', value: 'true' }],
    sri: [{ name: 'All funds', value: false }, { name: 'Sustainability mandate', value: '1' }],
    fundUssif: [{ name: 'All funds', value: false }, { name: 'US-SIF funds', value: '1.5' }],
    targetDate: [{ name: 'All funds', value: false }, { name: 'Target date funds', value: '1' }],
    fundPerformance: [{ name: 'All funds', value: false }, { name: 'Positive 1-year returns', value: 'trailing_return_y1' }, { name: 'Positive 3-year returns', value: 'trailing_return_y3' }, { name: 'Positive 5-year returns', value: 'trailing_return_y5' }, { name: 'Positive 10-year returns', value: 'trailing_return_y10' }, { name: 'Positive 15-year returns', value: 'trailing_return_y15' }, { name: 'Positive 20-year returns', value: 'trailing_return_y20' }],
    fffGrade: [{ name: 'All funds', value: false }, { name: 'Fossil fuel grade A', value: 1 }, { name: 'Fossil fuel grade B or higher', value: 2 }, { name: 'Fossil fuel grade C or higher', value: 3 }, { name: 'Fossil fuel grade D or higher', value: 4 }],
    ffbGrade: [{ name: 'All funds', value: false }, { name: 'Fossil finance grade A', value: 1 }, { name: 'Fossil finance grade B or higher', value: 2 }, { name: 'Fossil finance grade C or higher', value: 3 }, { name: 'Fossil finance grade D or higher', value: 4 }],
    ffiGrade: [{ name: 'All funds', value: false }, { name: 'Fossil insurance grade A', value: 1 }, { name: 'Fossil insurance grade B or higher', value: 2 }, { name: 'Fossil insurance grade C or higher', value: 3 }, { name: 'Fossil insurance grade D or higher', value: 4 }],
    dffGrade: [{ name: 'All funds', value: false }, { name: 'Deforestation grade A', value: 1 }, { name: 'Deforestation grade Engagement or higher', value: 1.5 }, { name: 'Deforestation grade B or higher', value: 2 }, { name: 'Deforestation grade C or higher', value: 3 }, { name: 'Deforestation grade D or higher', value: 4 }],
    gefGrade: [{ name: 'All funds', value: false }, { name: 'Gender equality grade A', value: 1 }, { name: 'Gender equality grade B or higher', value: 2 }, { name: 'Gender equality grade C or higher', value: 3 }, { name: 'Gender equality grade D or higher', value: 4 }],
    wffGrade: [{ name: 'All funds', value: false }, { name: 'Weapon grade A', value: 1 }, { name: 'Weapon grade B or higher', value: 2 }, { name: 'Weapon grade C or higher', value: 3 }, { name: 'Weapon grade D or higher', value: 4 }],
    gffGrade: [{ name: 'All funds', value: false }, { name: 'Civilian firearm grade A', value: 1 }, { name: 'Civilian firearm grade B or higher', value: 2 }, { name: 'Civilian firearm grade C or higher', value: 3 }, { name: 'Civilian firearm grade D or higher', value: 4 }],
    tffGrade: [{ name: 'All funds', value: false }, { name: 'Tobacco grade A', value: 1 }, { name: 'Tobacco grade Engagement or higher', value: 1.5 }, { name: 'Tobacco grade B or higher', value: 2 }, { name: 'Tobacco grade C or higher', value: 3 }, { name: 'Tobacco grade D or higher', value: 4 }],
    pffGrade: [{ name: 'All funds', value: false }, { name: 'Prison industrial complex grade A', value: 1 }, { name: 'Prison industrial complex grade B or higher', value: 2 }, { name: 'Prison industrial complex grade C or higher', value: 3 }, { name: 'Prison industrial complex grade D or higher', value: 4 }],
    clean: [{ name: 'All funds', value: false }, { name: 'A grade funds only', value: 'true' }],
    currency: [],
    currencyAll: [{ name: 'All funds' }, { name: 'US Dollar' }],
    currencyUS: [
      //
    ],
    currencyUK: [
      //
    ],
    currencyHK: [
      //
    ],
    currencyDK: [
      //
    ],
    currencyFR: [
      //
    ],
    currencyDE: [
      //
    ],
    fundGroup: [],
    fundGroupAll: [{ name: 'All funds' }, { name: 'Allocation' }, { name: 'International Equity' }, { name: 'Sector Equity' }, { name: 'U.S. Small/Mid Cap Equity' }, { name: 'U.S. Large Cap Equity' }],
    fundGroupUS: [
      //
    ],
    fundGroupUK: [
      //
    ],
    fundGroupHK: [
      //
    ],
    fundGroupDK: [
      //
    ],
    fundGroupFR: [
      //
    ],
    fundGroupDE: [
      //
    ],
    fundCategory: [],
    fundCategoryAll: FundCategoryAll,
    fundCategoryUS: [
      //
    ],
    fundCategoryUK: [
      //
    ],
    fundCategoryHK: [
      //
    ],
    fundCategoryDK: [
      //
    ],
    fundCategoryFR: [
      //
    ],
    fundCategoryDE: [
      //
    ],
    fundFamily: [],
    fundFamilyAll: FundFamilyAll,
    fundFamilyUS: [
      //
    ],
    fundFamilyUK: [
      //
    ],
    fundFamilyHK: [
      //
    ],
    fundFamilyDK: [
      //
    ],
    fundFamilyFR: [
      //
    ],
    fundFamilyDE: [
      //
    ]
  },
  /*ignore jslint end*/

  app: {
    title: title,
    description: description,
    head: {
      defaultTitle: title,
      titleTemplate: '%s | ' + title,
      meta: [{ name: 'description', content: description }, { charset: 'utf-8' },
      // twitter
      { property: 'twitter:card', content: 'summary_large_image' }, { property: 'twitter:site', content: '@fossilfreefunds' }, { property: 'twitter:title', content: title }, { property: 'twitter:description', content: description }, { property: 'twitter:creator', content: '@fossilfreefunds' }, { property: 'twitter:image', content: '' },
      // {property: 'twitter:image', content: ''},

      // og
      { property: 'og:site_name', content: title }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: domain }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: '' }]
    }
  }
};
// inject the serverconfig if its on the browser
if (typeof window !== 'undefined') {
  config = (0, _assign2.default)({}, config, window.__serverConfig);
}
module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 10
// module chunks = 0